import { Button, Col, Input, Row, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE, ACCOUNT_TYPE } from "../../../constants";
import useApi from "../../../hooks/useApi";
import TableComponent from "../../common/table/TableComponent";
import AddAccount from "./AddAccount";
import {
  isEmpty,
  replaceBlankValueToUndefined,
} from "../../../generalFunctions";

function AccountTable(props) {
  const columns = [
    {
      title: "Account Name",
      dataIndex: "accountName",
    },
    {
      title: "Account Type",
      dataIndex: "accountType",
      render: (text, record) => getAccountType(text),
    },
    {
      title: "Commission %",
      dataIndex: "commission",
      width: "150px",
    },
    {
      title: "Action",
      key: "action",

      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => editRecord(record)}>
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  const [responseData, getRequest] = useApi(
    "/config/account",
    null,
    API_METHODS.GET
  );
  const [visible, setVisible] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [tableData, setTableData] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchAccountResponse, searchAccountRequest] = useApi(
    `/config/account/`,
    null,
    API_METHODS.GET
  );
  const [isSearched, setIsSearched] = useState(false);
  useEffect(() => {
    getRequest(null, API_METHODS.GET, `/config/account?pageNumber=${1}`);
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    setTableData(data);
    setTotalRecords(data && data.length > 0 ? data[0].count : 0);
  }, [responseData]);

  const handleAddAccount = (isUpdated) => {
    const flag = visible ? false : true;
    setVisible(flag);
    if (isUpdated === true) {
      getRequest(null, API_METHODS.GET, `/config/account?pageNumber=${1}`);
      props.refreshClientConfig();
    }
  };

  const handleEditAccount = (isUpdated) => {
    const flag = visibleEdit ? false : true;
    !flag && setSelectedRecord(null);
    setVisibleEdit(flag);
    if (isUpdated === true) {
      getRequest(null, API_METHODS.GET, `/config/account?pageNumber=${1}`);
      props.refreshClientConfig();
    }
  };

  const editRecord = (record) => {
    setVisibleEdit(true);
    setSelectedRecord(replaceBlankValueToUndefined(record));
  };

  const onPaginationChange = (page) => {
    getRequest(
      null,
      API_METHODS.GET,
      `/config/account?pageNumber=${page.current}`
    );
    setCurrentPage(page.current);
  };

  const getAccountType = (shortName) => {
    if (isEmpty(shortName)) {
      return " ";
    }
    return ACCOUNT_TYPE.find((type) => type.key === shortName).value;
  };

  const onSearch = (accountName) => {
    if (!isEmpty(accountName)) {
      setIsSearched(true);
      searchAccountRequest(
        null,
        API_METHODS.GET,
        `/config/account/${accountName}`
      );
    } else {
      setIsSearched(false);
      getRequest(
        null,
        API_METHODS.GET,
        `/config/account?pageNumber=${currentPage}`
      );
    }
  };

  useEffect(() => {
    const data =
      searchAccountResponse.data !== BLANK_VALUE
        ? searchAccountResponse.data
        : [];
    setTableData(data);
  }, [searchAccountResponse]);

  return (
    <>
      <Row>
        <Col span={6}>
          <Typography.Title level={5}>Accounts</Typography.Title>
        </Col>
        <Col span={18}>
          <Space style={{ marginBottom: 10, float: "right" }}>
            <Input.Search
              placeholder="Account Name"
              allowClear
              enterButton="Search"
              onSearch={onSearch}
            />
            <Button type="primary" onClick={handleAddAccount}>
              Add Account
            </Button>
          </Space>
        </Col>
      </Row>
      {!isSearched && (
        <TableComponent
          columns={columns}
          tableData={tableData}
          loading={responseData.isLoading}
          onPaginationChange={onPaginationChange}
          total={totalRecords}
          current={currentPage}
        />
      )}
      {isSearched && (
        <TableComponent
          columns={columns}
          tableData={tableData}
          loading={searchAccountResponse.isLoading}
          clientSideRender={true}
        />
      )}
      {visible && <AddAccount visible={visible} close={handleAddAccount} />}
      {visibleEdit && (
        <AddAccount
          visible={visibleEdit}
          selectedRecord={selectedRecord}
          close={handleEditAccount}
        />
      )}
    </>
  );
}

export default AccountTable;
